<template>
  <div class="training-plans-layout trainplansroot">
    <div
      class="plans-svg-back"
      :style="
        $route.name === 'StudyPlansDashboard'
          ? 'top: -12.5%; left: 0%; width: 145%; opacity:0.75'
          : 'top: -12.5%; left: -10%; width: 145%; opacity:1'
      "
      style="position: absolute; transition: 0.22s ease-out; z-index: 1"
    >
      <svg
        v-for="(item, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]"
        id="Layer_1"
        :key="index"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1041 409"
        xml:space="preserve"
        style="position: absolute; left: 0; z-index: -1"
        :style="`
        top: ${index + 4 * index - 7}vh;
        `"
      >
        <linearGradient
          id="SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1="513.4135"
          y1="221.3255"
          x2="545.6004"
          y2="144.2585"
          gradientTransform="matrix(1 0 0 -1 0 410)"
        >
          <stop
            offset="0"
            style="stop-color: var(--clr-primary-3)"
          />
          <stop
            offset="1"
            style="stop-color: var(--clr-black-1)"
          />
        </linearGradient>
        <path
          style="fill: none; stroke: url(#SVGID_1_); stroke-miterlimit: 10"
          d="M1039.6,1c-26.4,44.8-73.2,55.7-119.6,68.7
	c-22.8,6.4-45.6,15.1-66.9,28c-61.7,37.5-79.1,79.7-156.8,101.7c-25,7.1-59,1.3-96-2c-96.3-8.6-177.4,25.3-238.9,63.2
	c-4,2.3-7.7,4.4-11.3,6.9c-54.8,34.9-93.2,79.1-148.2,105.5c-12.7,6.2-26.5,10.8-41.5,13.9C108,398.4,54.9,402.1,0.2,408"
        />
      </svg>
    </div>

    <div
      class="trainplansroot_center small-scroll-track"
      style="z-index: 2"
    >
      <router-view v-slot="{ Component }">
        <transition
          name="slide"
          mode="out-in"
        >
          <component
            :is="Component"
            :ref="$route.name"
          />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudyPlansRoot',
}
</script>
<style lang="scss" scoped>
.trainplansroot {
  background: linear-gradient(88deg, var(--clr-black-0), var(--clr-black-0-4));
}
@media (max-width: 1023px) {
  .trainplansroot {
    min-height: var(--vh-3);

    min-width: 100vw;
    &_center {
      min-height: var(--vh-3);

      min-width: 100vw;
    }
  }
}
.trainplansroot {
  flex: 1;
  display: flex;
  &_center {
    height: var(--vh-3);
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &_left {
    width: var(--left-sidebar-width);
    padding: 0.5rem 0;
    background: var(--clr-black-1);
  }
}
</style>
